module.exports = __webpack_public_path__ + "img/help-circle.613cacf1.svg";